import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-008db79c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "flex items-center -gap-x-4 px-6" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-2xl" }
const _hoisted_5 = { class: "mt-4 text-gray-500 text-sm" }

import { computed } from 'vue';
import { RegionDto } from 'src/api/types';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvVerticalTabs',
  props: {
    regions: {},
    tab: {}
  },
  emits: ["update:tab"],
  setup(__props: any) {

const { t } = useI18n();

const props = __props;



const tab = computed(() => props.tab);

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_card, { class: "flex bg-white" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tabs, {
          class: "flex-none",
          "model-value": tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => _ctx.$emit('update:tab', val)),
          "active-class": "text-green-600 bg-green-100",
          "indicator-color": "transparent",
          vertical: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (page, i) => {
              return (_openBlock(), _createBlock(_component_q_tab, {
                key: page.id,
                class: "flex justify-start",
                name: i,
                ripple: false,
                "no-caps": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    (page.icon)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "w-6 h-6",
                          src: page.icon,
                          alt: "icon"
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(page.name
                  ?.replace(_unref(t)('SvVerticalTabs.headquarters'), '')
                  .replace(_unref(t)('SvVerticalTabs.branchOffices'), '')), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model-value"]),
        _createVNode(_component_q_tab_panels, {
          class: "h-full flex-1",
          "model-value": tab.value,
          animated: "",
          swipeable: "",
          vertical: "",
          "transition-prev": "jump-up",
          "transition-next": "jump-up"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (page, i) => {
              return (_openBlock(), _createBlock(_component_q_tab_panel, {
                key: page.id,
                class: "px-6 py-6",
                name: i
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "grid content-between h-full",
                    style: _normalizeStyle(`background: url('${page.image}') no-repeat bottom right; background-size: 50% auto;`)
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(page.name), 1),
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((page.summary ?? '').split('\n'), (p, i) => {
                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                        }), 128))
                      ])
                    ])
                  ], 4)
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      _: 1
    })
  ]))
}
}

})